const DoctorAppointments = () =>
  import(
    /* webpackChunkName: "Appointments" */ "@/components/dashboard/patient/appointments/DoctorAppointment"
  );
const DiagnosticAppointments = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/diagnostics/DiagnosticAppointments"
  );

const AmbulanceBookings = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/ambulanceN/ambulanceBookings.vue"
  );
const AmbulanceAppointments = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/ambulance/AmbulanceAppointments"
  );
const CurrentBookings = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/ambulance/CurrentBookings"
  );
const UpcomingBookings = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/ambulance/UpcomingBookings"
  );
const CompletedBookings = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/ambulance/CompletedBookings"
  );
const CancelledBookings = () =>
  import(
    /* webpackChunkName: "Appointments" */
    "@/components/dashboard/patient/appointments/ambulance/CancelledBookings"
  );
  // const NewPatientDashboard = () =>
  // import(
  //   /* webpackChunkName: "Appointments" */
  //   "@/components/dashboardNew/patientDashboard"
  // );

export default [
  // {
  //   path: "",
  //   name: "dashboard.patient.appointments.root",
  //   redirect: {
  //     name: "dashboard.patient.appointments.doctors"
  //   },
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: "doctors",
    name: "dashboard.patient.appointments.doctors",
    component: DoctorAppointments,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "diagnostics/:tab?",
    name: "dashboard.patient.appointments.diagnostics",
    component: DiagnosticAppointments,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "ambulance",
    name: "dashboard.patient.appointments.ambulance",
    component: AmbulanceBookings
    // meta: {
    //   requiresAuth: true
    // }
  },

  {
    path: "ambulance",
    name: "dashboard.patient.appointments.ambulance",
    component: AmbulanceAppointments,
    children: [
      {
        path: "",
        name: "dashboard.patient.appointments.ambulance.root",
        redirect: {
          name: "dashboard.patient.appointments.ambulance.upcomingBookings"
        },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "current",
        component: CurrentBookings,
        name: "dashboard.patient.appointments.ambulance.currentBookings",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "upcoming",
        component: UpcomingBookings,
        name: "dashboard.patient.appointments.ambulance.upcomingBookings",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "completed",
        component: CompletedBookings,
        name: "dashboard.patient.appointments.ambulance.completedBookings",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "cancelled",
        component: CancelledBookings,
        name: "dashboard.patient.appointments.ambulance.cancelledBookings",
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];
